/**
 * LastReviewedStamp - Reusable "Last reviewed by BuildPilot" component.
 *
 * Drops below the H1 on any editorial / pillar page. Outputs a `<time>`
 * element with the ISO `dateTime` attribute (Google freshness signal)
 * and visible "Last reviewed by BuildPilot - 15 February 2026" copy.
 *
 * Usage:
 *   <LastReviewedStamp date="2026-02-15" />
 *
 * Convention: refresh quarterly. Update `date` per page in a small data
 * table rather than chasing each page individually.
 */
import React from 'react';

const LastReviewedStamp = ({ date, className = '', testid = 'last-reviewed' }) => {
  if (!date) return null;
  const d = new Date(date);
  const label = d.toLocaleDateString('en-AU', { day: 'numeric', month: 'long', year: 'numeric' });
  return (
    <p
      className={`text-[12px] sm:text-[13px] text-white/55 ${className}`}
      data-testid={testid}
    >
      Last reviewed by BuildPilot ·{' '}
      <time dateTime={date}>{label}</time>
    </p>
  );
};

export default LastReviewedStamp;
